import { AddQuoteProductCatalogDrawerFormValues } from "@/Contracts/ProposalBuilder/Block";

const scale = (value: number | undefined | null, rate: number): number =>
	(value ?? 0) * rate;

export const convertQuoteProductPricesToQuoteCurrency = (
	product: AddQuoteProductCatalogDrawerFormValues,
	rate: number
): AddQuoteProductCatalogDrawerFormValues => ({
	...product,
	selected_cost_price: scale(product.selected_cost_price, rate),
	selected_setup_price: scale(product.selected_setup_price, rate),
	sell_price: scale(product.sell_price, rate),
	selected_sell_price: scale(product.selected_sell_price, rate),
	sub_total: scale(product.sub_total, rate),
	bundled_products: product.bundled_products?.map(child => ({
		...child,
		selected_cost_price: scale(child.selected_cost_price, rate),
		selected_sell_price: scale(child.selected_sell_price, rate),
		selected_setup_price: scale(child.selected_setup_price, rate),
		sell_price: scale(child.sell_price, rate),
		sub_total: scale(child.sub_total, rate)
	}))
});
